"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var modal_1 = __importDefault(require("../../../plugins/modal"));
var quantity_picker_1 = __importDefault(require("../../bundler/components/quantity-picker"));
var is_variant_available_1 = __importDefault(require("../../bundler/is-variant-available"));
var utils_1 = require("../../account-v3/utils");
var app_1 = require("../app");
var details_modal_1 = __importDefault(require("../components/details-modal"));
var size_up_modal_1 = __importDefault(require("../components/size-up-modal"));
var step_header_1 = __importDefault(require("../components/step-header"));
var useContext = React.useContext, useMemo = React.useMemo, useState = React.useState, useEffect = React.useEffect;
exports.default = (function () {
    var _a, _b, _c, _d;
    var _e = useContext(app_1.AppContext), addChoice = _e.addChoice, availableChoices = _e.availableChoices, availableSizes = _e.availableSizes, choices = _e.choices, setLeftSideImage = _e.setLeftSideImage, size = _e.size, subChoice = _e.subChoice, totalNumChoices = _e.totalNumChoices;
    var productsData = (_a = window.vitaminBundlerApp) === null || _a === void 0 ? void 0 : _a.productsData;
    var _f = __read(useState(null), 2), modalChoice = _f[0], setModalChoice = _f[1];
    var _g = __read(useState(undefined), 2), sizeUpModalChoice = _g[0], setSizeUpModalChoice = _g[1];
    setLeftSideImage((_b = window.vitaminBundlerApp) === null || _b === void 0 ? void 0 : _b.settings.selectVitamins.leftImage);
    // sort choices by alphabetical, OOS at the bottom
    var sortedChoices = useMemo(function () { return availableChoices.sort(function (a, b) { return (a.product.title < b.product.title ? 1 : -1); }).sort(function (_a) {
        var variant = _a.variant;
        return ((0, is_variant_available_1.default)(variant) ? -1 : 1);
    }); }, []);
    useEffect(function () {
        var _a;
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'vitaminBundle__selectVitamins', selectedSize: size });
    }, []);
    var addChoiceWithSizeUpModal = function (choice) {
        if (!size) {
            return;
        }
        if (totalNumChoices === size && size !== availableSizes[availableSizes.length - 1]) {
            setSizeUpModalChoice(choice);
        }
        else if (totalNumChoices < size) {
            if (choice) {
                addChoice(choice);
            }
        }
    };
    var handleModalChoiceClick = function (choice) { return function () {
        if (choice) {
            setModalChoice(choice);
        }
    }; };
    return (React.createElement("div", { className: 'grid-container vitamin-bundler-select-vitamins' },
        React.createElement(step_header_1.default, { title: (_c = window.vitaminBundlerApp) === null || _c === void 0 ? void 0 : _c.settings.selectVitamins.title, subtitle: (_d = window.vitaminBundlerApp) === null || _d === void 0 ? void 0 : _d.settings.selectVitamins.subtitle },
            React.createElement("div", { className: 'padding-top-6 medium-padding-top-10' },
                "(",
                totalNumChoices,
                " of ",
                size,
                ")")),
        React.createElement("div", { className: 'grid-x small-up-2 medium-up-3 large-up-4 grid-margin-x grid-margin-y' }, sortedChoices.map(function (_a) {
            var product = _a.product, variant = _a.variant;
            var productData = productsData && productsData[product.handle];
            var variantData = productData === null || productData === void 0 ? void 0 : productData.variants[variant.id];
            var numSelected = choices.filter(function (c) { return c.product.id === product.id && c.variant; }).reduce(function (sum, c) { return sum + c.quantity; }, 0);
            return (React.createElement(quantity_picker_1.default, { key: variant.id, addChoice: addChoiceWithSizeUpModal, bundleType: 'vitamin', isAvailable: (0, is_variant_available_1.default)(variant), isLowStock: (0, utils_1.isVariantLowStock)(variant), numSelected: numSelected, product: product, setModalChoice: handleModalChoiceClick({ product: product, variant: variant }), subChoice: subChoice, variant: variant, variantData: variantData }));
        })),
        React.createElement(modal_1.default, { isOpen: !!modalChoice, handleClose: function () { return setModalChoice(null); }, style: { content: { maxWidth: '400px' } } }, modalChoice ? React.createElement(details_modal_1.default, { availableChoice: modalChoice }) : null),
        React.createElement(modal_1.default, { isOpen: !!sizeUpModalChoice, handleClose: function () { return setSizeUpModalChoice(undefined); }, style: { content: { maxWidth: '400px' } } }, sizeUpModalChoice ? React.createElement(size_up_modal_1.default, { closeModal: function () { return setSizeUpModalChoice(undefined); }, incomingChoice: sizeUpModalChoice }) : null)));
});
